// Colocated strings for WelcomeDialog (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by the SFC as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// Lifted verbatim from the app's `src/locales.js` — one file per locale that bundle
// actually has (10; the all-empty `defaultLocale` bundle no longer exists).
// `{projectName}` in `welcomeMessage` is the one interpolation; keep it verbatim.
//
// TRANSLATION TICKET — `loaded`: the "<n> / <n> loaded" progress caption existed in NO bundle
// of `locales.js`, so `t('loaded')` used to miss both scopes and render the raw key (which in
// English happens to read correctly). S8 bit 2 added it here with the ENGLISH text in all 10
// files, like `DuckDBQueryDialog`'s two keys: the key now resolves in the local scope, so the
// `[intlify] Not found 'loaded' key` warning is gone and no locale can fall through to a blank.
// Replace a file's value as its translation lands. `vi` (the 11th locale, 2026-10-28) shipped it
// translated, as it did the marketing panel below (RKive and Golden Thread kept as brands).
//
// TRANSLATION TICKET — the marketing panel (`showMarketingPanel`): `discoverTitle` and the
// `discover<Item>` / `discover<Item>Text` pairs (one per entry of ../marketingItems.js) came from
// issue-analysis's WelcomeDialog.vue, where they were hard-coded English with no entry in any
// bundle of its `locales.js`. They are ENGLISH in the first 10 files until translated; the item
// titles are product names (RKive and Golden Thread are brands — translators may keep them).
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
